import { autorun, makeAutoObservable } from 'mobx';

class NotificationStore {

  error;

  constructor() {
    this.error = null;
    makeAutoObservable(this);
    autorun(() => this.errorTimeout());
  }

  setError = (msg) => {
    this.error = msg;
  };

  errorTimeout = () => {
    if (this.error) {
      setTimeout(() => {
        this.setError(null);
      }, 5000);
    }
  };

}

export default new NotificationStore();
